import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useState } from 'react';
import { StyledBarContainer } from '../app-usage-chart/app-usage-chart.style';

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
    labels: ['Lecturers', 'Students'],
    datasets: [
        {
            data: [16, 55],
            backgroundColor: [
                '#4B5879',
                '#FF348E',
            ],
            borderWidth: 1,

        },
    ],
};

const UserChart = () => {
    const [chartData, setChartData] = useState(data)
    return (
        <StyledBarContainer>
            <div className="container-top">
                <h3>User Pie Chart</h3>
            </div>
            <div
                style={{ padding: "2rem 1.9rem 1.7rem 2.4rem" }}
            >
                <Doughnut data={chartData} options={{
                    plugins: {
                        legend: {
                            position: 'bottom',
                            align: 'center'
                        }
                    }
                }
                } />
            </div>
        </StyledBarContainer>
    )
}

export { UserChart }
